<template>
  <form
    ref="form"
    enctype="multipart/form-data"
    data-url="/accreditationtechnical/signatureDocument/signatureDocumentReport/updateSamplingFile"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Plan de muestreo <small class="text-danger">*</small></label>
          <app-input
            type="file"
            v-model="inputs.file_1"
            id="sampling_plan_file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-if="!inputs.sampling_plan_file"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('sampling_plan_file')"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      showInput: false,
      deleteModal: false,
    };
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.inputs = {
        id: this.$store.state.evaluatorReview.evalTest.id,
        evaluation_plan_report: this.$store.state.evaluatorReview.evalTest
          .evaluation_plan_report,
        sampling_plan_file: this.$store.state.evaluatorReview.evalTest
          .sampling_plan_file,
      };
    },
  },
  created() {
    if (this.$store.state.evaluatorReview.evalTest) {
      this.inputs = {
        id: this.$store.state.evaluatorReview.evalTest.id,
        sampling_plan_file: this.$store.state.evaluatorReview.evalTest
          .sampling_plan_file,
      };
    }
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    afterSuccess({ data: { data } }) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    openTab() {
      const w = window.open(this.inputs.sampling_plan_file.path, "_blank");
      w.focus();
    },
  },
};
</script>
